import { useQuery } from "@tanstack/react-query";
import { FOUNDING_ENROLLMENT_QUERY_KEY } from "./constants";
import { fetchFoundingEnrollment } from "./founding-api";

/**
 * A single property's founding enrollment (ADR-0010).
 *
 * `enabled` gates the fetch so a viewer who would 403 on the founding
 * endpoints (e.g. SUPPORT) never triggers a request — the property-detail
 * discount view is ADMIN/FINANCE only. Returns `null` (not an error) when the
 * property has no enrollment.
 */
export function useFoundingEnrollment(propertyId: string, enabled: boolean) {
  return useQuery({
    queryKey: [...FOUNDING_ENROLLMENT_QUERY_KEY, propertyId] as const,
    queryFn: () => fetchFoundingEnrollment(propertyId),
    enabled: enabled && propertyId.length > 0,
    staleTime: 30_000,
  });
}
